export default __webpack_public_path__ + "static/location-europe-519c2b434cf13139d68e3bb42e11c4c7.png";